import React from 'react';
import PimsSync from 'shared/components/PimsSync';
import { PimsIntegrationCapability } from 'shared/types/graphql';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Box, Divider, HStack, VStack } from '@televet/kibble-ui/build/chakra';
import { Link } from '@televet/kibble-ui';

interface IClientSearchResultProps {
  icon: JSX.Element;
  messageText: string;
  backgroundColor: string;
  callToActionText?: string;
  callToActionFunction?: (data?: any) => void; //eslint-disable-line @typescript-eslint/no-explicit-any
  mixpanelAttribute?: string;
  children?: JSX.Element[];
  shouldShowPimsSync?: boolean;
  triggerSearch?: () => void;
  secondaryCallToAction?: JSX.Element;
  resetSyncState?: () => void;
  shouldSync?: boolean;
}

const syncClientModels = [
  PimsIntegrationCapability.ClinicPetParent,
  PimsIntegrationCapability.ClinicPet,
  PimsIntegrationCapability.ClinicPetToClinicPetParent,
];

const ClientSearchResult = ({
  icon,
  messageText,
  callToActionText,
  callToActionFunction,
  mixpanelAttribute,
  backgroundColor,
  children,
  triggerSearch = (): void => {
    return;
  },
  secondaryCallToAction,
  shouldSync = false,
  resetSyncState = (): void => {
    return;
  },
  shouldShowPimsSync = false,
}: IClientSearchResultProps): JSX.Element => {
  return (
    <Box>
      <VStack bg={backgroundColor} borderRadius="md" alignItems="flex-start" justify="space-evenly" p={3} mt={4}>
        <HStack align="center" justify="flex-start">
          <Box>{icon}</Box>
          <Box>
            <Text size="sm">{messageText}</Text>
            {secondaryCallToAction}
            <Link size="sm" onClick={callToActionFunction} data-mixpanel-name={mixpanelAttribute}>
              {callToActionText}
            </Link>
          </Box>
        </HStack>
        {shouldShowPimsSync && (
          <>
            <Divider />
            <Box w="100%">
              <PimsSync
                triggerSearch={triggerSearch}
                shouldSync={shouldSync}
                resetSyncState={resetSyncState}
                parentComponent="Client Search Result"
                syncModels={syncClientModels}
              />
            </Box>
          </>
        )}
      </VStack>
      {children}
    </Box>
  );
};

export default ClientSearchResult;
